'use client';
const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.c6df987ca5ca6a2219495c5968a84b95.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.0ff164770fc88ff63d26d5f08f4c1610.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.f1ed7ff4b7a05a7da3079abc025cd8d7.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.765c4e93b29759cbca84760372e4c2bb.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.710495a890b50ac38b375827a0fe8bac.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.8a17741c51315f2745a3b8a72df30971.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.4e52d9069a843e8ca01301fc7f341565.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.e3d7c01b83b57808374ba6b3315fd47e.min.css',
        versioned: 'step-indicator.min.css'
    },
    statusMessage: {
        hashed: 'status-message.5a5dae6bd07da8296f6aedf3d0beb7aa.min.css',
        versioned: 'status-message.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.ba88f90b2f9704ba4f2a7b5dd8220600.min.css',
        versioned: 'standard-tile.min.css'
    },
    spinner: {
        hashed: 'spinner.e28c0ae32bd5b461b339d7683cf90c86.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.0c4a12a22f2521a435dfe06a092224ed.min.css',
        versioned: 'selection-set.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.e164eed6ff785abfb972c16df7ae04b5.min.css',
        versioned: 'ratings-stars.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.62a0f2a9125f6611361a9becb64edc21.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.079ed7a8b72a43c295d80b33bc4a20b3.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.5902fef312e36d0ff416e2cdd940d7ae.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.f233f3b83e9f6b45c7574578868dfeab.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.b8d74c8d2e558343f36e7bcfc7560056.min.css',
        versioned: 'modal-dialog.min.css'
    },
    listbox: {
        hashed: 'listbox.4cb0c7173325cfae3eb3610462007e28.min.css',
        versioned: 'listbox.min.css'
    },
    icon: {
        hashed: 'icon.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.393ab9dc32ba1b6be15bf4d30fc3c6d6.min.css',
        versioned: 'grid.min.css'
    },
    fileTile: {
        hashed: 'file-tile.c01573e89aa2fdceb71f85374779daad.min.css',
        versioned: 'file-tile.min.css'
    },
    fileDropzone: {
        hashed: 'file-dropzone.8791a0f195bddf0b5fde79482b9d6426.min.css',
        versioned: 'file-dropzone.min.css'
    },
    fieldSet: {
        hashed: 'field-set.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'field-set.min.css'
    },
    emptyState: {
        hashed: 'empty-state.46e5c6ac5dc9486f3ced02f03841f060.min.css',
        versioned: 'empty-state.min.css'
    },
    carousel: {
        hashed: 'carousel.d25f4f3f9f99a03ca51e91b7d4b5eaed.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'button.min.css'
    },
    baseTile: {
        hashed: 'base-tile.76bdbbb3cbef836fb15b21fe2deec532.min.css',
        versioned: 'base-tile.min.css'
    },
    banner: {
        hashed: 'banner.10723b28770347b23fbc989fcabb19e8.min.css',
        versioned: 'banner.min.css'
    },
    avatar: {
        hashed: 'avatar.d67d114201fbc23f9ebe19c0ae0dd88d.min.css',
        versioned: 'avatar.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.180c2e853ce2d0fd9394f4c6f9c2dcca.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.cc2dbad59124cc47e742dcb7515d5675.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.b1cc9beb570dd47b8288e61ec77a4568.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
